/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import moment from 'moment';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import _size from 'lodash/size';
import _chunk from 'lodash/chunk';

import {GetLocaleForMoment} from '../../utils';
import {OpenProfileFor} from '../../actions/common/actions-common';
import {FetchAssetById} from '../../actions/asset/action-asset';

import Translate from '../../components/Translate';
import DivLoader from '../../components/DivLoader';
import ShowcaseRow from '../../components/ShowcaseCollection/showcase-collection-row';

class ShowcaseNotifications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: '',
      icon: '',
      extendedRow: null,
      extendedCol: null
    };
  }

  componentDidMount() {

    if (this.props.type === 'channel' && !this.props.channel) {

      this.props.FetchAssetById(this.props.meta.channel_id);
    }

    if (this.props.type === 'channel' && this.props.channel) {

      lh.models.asset.methods.getPosterUrl(this.props.channel, {
        crop: {x: 46, y: 46},
        cache: false
      })
        .then((url) => {
          this.setState({icon: url});
        }, () => {
        });
    }

    if (this.props.globalProfile && this.props.id !== this.props.globalProfile) {

      this._onCollapseRow();
    }
  }

  componentWillReceiveProps(newProps) {
    if (!_isEqual(_get(this.props, 'notifications'), _get(newProps, 'notifications'))) {

      this._onCollapseRow();
    }

    if (newProps.type === 'channel' && !newProps.channel && this.props.type !== 'channel') {

      this.props.FetchAssetById(newProps.meta.channel_id);
    }

    if (newProps.type === 'channel' && _get(newProps, 'channel.id') !== _get(this.props ,'channel.id')) {

      lh.models.asset.methods.getPosterUrl(newProps.channel, {
        crop: {x: 46, y: 46},
        cache: false
      })
        .then((url) => {
          this.setState({icon: url});
        }, () => {
        });
    }

    if (newProps.globalProfile && newProps.id !== newProps.globalProfile) {

      this._onCollapseRow();
    }
  }

  _onExtendRow(row, col) {

    this.setState({extendedRow: row, extendedCol: col});
    this.props.OpenProfileFor(this.props.id);
  }

  _onCollapseRow() {

    this.setState({extendedRow: null, extendedCol: null});
  }

  _renderHeader() {

    switch (this.props.type) {

      case 'date':

        return (
          <div id="showcase-header" className="blocks-row clearfix">
            <ul className="menu block-3 radius bg-black">
              <li className="block-1">
                <a className="pad-lr hover pointer">
                  <i className="ic ic-calendar-clock ic-18px" style={{position: 'relative', top: '22px'}}></i>
                </a>
              </li>
              <li className="block-1">
                <a className="pad-lr hover container pointer">
                  <span><strong>{moment(_get(this.props, 'meta.title', '')).locale(GetLocaleForMoment()).calendar()}</strong></span>
                </a>
              </li>
              <li className="block-1 m0">
                <a className="pad-lr hover container pointer">
                  <span><strong>{_get(this.props, 'meta.title', '').format(_get(Config, 'epg.epg_day_format', 'D MMMM'))}</strong></span>
                </a>
              </li>
            </ul>
          </div>
        );

      case 'alphabet':

        return (
          <div id="showcase-header" className="blocks-row clearfix">
            <ul className="menu block-3 radius bg-black">
              <li className="block-1">
                <a className="pad-lr hover container pointer">
                  <span className="profile-bigtext m0"><strong>{_get(this.props, 'meta.title', '')}</strong></span>
                </a>
              </li>
            </ul>
          </div>
        );

      case 'channel':

        return (
          <div id="showcase-header" className="blocks-row clearfix">
            <ul className="menu block-3 radius bg-black">
              {_get(this.state, 'icon') && <li className="block-1">
                <a className="pad-lr hover pointer">
                <span className="icon">
                  <img alt="" src={_get(this.state, 'icon')} style={{marginTop: '2px'}}/>
                </span>
                </a>
              </li>}
              <li className="block-1">
                <a className="pad-lr hover container pointer">
                  <span><strong>{_get(this.props, 'channel.title', '')}</strong></span>
                </a>
              </li>
            </ul>
          </div>
        );

      default:

        return (
          <div id="showcase-header" className="blocks-row clearfix">
            <ul className="menu block-3 radius bg-black">
              {_get(this.props, 'meta.icon') && <li className="block-1">
                <a className="pad-lr hover pointer">
                <span className="icon">
                  <img alt="" src={_get(this.props, 'meta.icon')} />
                </span>
                </a>
              </li>}
              <li className="block-1">
                <a className="pad-lr hover container pointer">
                  <span><strong>{_get(this.props, 'meta.title', '')}</strong></span>
                </a>
              </li>
            </ul>
          </div>
        );
    }

  }

  _renderNpvrRows() {
    if (!_get(this.props, 'notifications')) {
      return null;
    }

    return _chunk(this.props.notifications, '4').map((chunk, index) => {
      return <ShowcaseRow
        key={`row_${index}`}
        assets={chunk}
        row={index}
        onExtendRow={this._onExtendRow.bind(this)}
        isExtend={this.state.extendedRow === index}
        sel_row={this.state.extendedRow}
        sel_col={this.state.extendedCol}/>
    });
  }

  render() {

    return (
      <div style={{position: 'relative'}}>
        {this._renderHeader()}
        <div id="showcase-row-container">
          {this._renderNpvrRows()}
        </div>
        { (this.props.inProgress) &&
        <div className="profile-container">
          <div id="showcase_row" style={{height: '132px', position: 'relative'}}>
            <div className="blocks-row clearfix showcase-row radius" style={{height: '100%'}}>
              <DivLoader loading={this.props.inProgress} />
            </div>
          </div>
        </div>
        }
        { (this.props.notifications && !_size(this.props.notifications) ) && <div id="showcase-empty-container">
          <div className="ui dimmer visible active radius">
            <div className="content">
              <div className="center">
                <h2 className="ui inverted icon header">
                  <Translate content="empty_section" />
                </h2>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    );
  }
}

ShowcaseNotifications.propTypes = {
  meta: PropTypes.object,
  notifications: PropTypes.array,
  /**
   * @connect props
   */
  FetchAssetById: PropTypes.func,
  SetPlayer: PropTypes.func
};

const mapStateToProps = ({assets, common: {profile}}, ownProps) => {
  if (ownProps.type === 'channel') {

    let channel = _get(assets, _get(ownProps, 'meta.channel_id'));

    return {
      channel,
      globalProfile: profile
    };
  } else {

    return {
      globalProfile: profile
    };
  }
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({FetchAssetById, OpenProfileFor}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowcaseNotifications);



// WEBPACK FOOTER //
// ./src/containers/ShowcaseNotifications/showcase-notifications.js